'use strict';

/**
 * Id of an execution context.
 *
 * @export
 */
export type ExecutionContextId = number;
